import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';
import './styles/common.css';
import './styles/buttons.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';

// TODO: Remove once reactstrap is upgraded to v9 (Bootstrap 5 migration).
// reactstrap@8 function components (Navbar, etc.) use defaultProps which is
// deprecated in React 18.3 and will be removed in React 19.
const _consoleError = console.error.bind(console);
console.error = (...args: any[]) => {
	if (typeof args[0] === 'string' && args[0].includes('Support for defaultProps will be removed')) return;
	_consoleError(...args);
};
// Create browser history to use in the Redux store
export const history = createBrowserHistory();
export const store = configureStore(history);

const rootElement = document.getElementById('root');

document.addEventListener('visibilitychange', (event) => {
	localStorage.setItem('reduxState', JSON.stringify(store.getState()));
});

// const saveState = () => localStorage.setItem('reduxState', JSON.stringify(store.getState()));
// document.addEventListener('visibilitychange', saveState);
// window.addEventListener('beforeunload', saveState);
// window.addEventListener('pagehide', saveState);

if (rootElement) {
	const root = createRoot(rootElement);
	root.render(
		<Provider store={store as any}>
			<ConnectedRouter history={history}>
				<ErrorBoundary>
					<App />
				</ErrorBoundary>
			</ConnectedRouter>
		</Provider>,
	);
}
